// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resizable-wrapper {
  position: relative;
  height: 100%;
}

.resizable-container {
  height: 100%;
  position: relative;
  transition: width 0.2s ease;
}

/* Disable transitions during resize */
body.resizing-leftbar .resizable-container,
body.resizing-leftbar .workspace-sidebar,
body.resizing-leftbar .leftbar {
  transition: none !important;
}

.resize-handle {
  position: absolute;
  right: -8px;
  top: 0;
  bottom: 0;
  width: 16px; /* Wider handle for easier grabbing */
  cursor: col-resize;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resize-handle-inner {
  height: 40px;
  width: 4px;
  background-color: transparent;
  border-radius: 2px;
  transition: background-color 0.2s;
}

/* .resize-handle:hover .resize-handle-inner {
  background-color: rgba(0, 0, 0, 0.1);
} */

/* .resize-handle:active .resize-handle-inner {
  background-color: rgba(0, 0, 0, 0.2);
} */

/* Override react-resizable styles for better appearance */
.react-resizable-handle {
  background-image: none !important;
  width: 16px !important;
}

/* Add a visual indicator when resizing */
body.resizing-leftbar::after {
  content: '';
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  z-index: 99;
  cursor: col-resize;
}

/* Optimize rendering during resize */
.resizable-container * {
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

/* Ensure sidebar transitions smoothly */
.workspace-sidebar {
  transition: left 0.2s ease;
}

/* Prevent text selection during resize */
body.resizing-leftbar {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

/* Improve performance during resize */
body.resizing-leftbar * {
  pointer-events: none;
}

/* But keep pointer events on the resize handle */
body.resizing-leftbar .resize-handle,
body.resizing-leftbar .resize-handle * {
  pointer-events: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ResizeableSlider/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,WAAW,EAAE,qCAAqC;EAClD,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH,0DAA0D;AAC1D;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,wCAAwC;AACxC;EACE,0BAA0B;AAC5B;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;AACtB;;AAEA,iDAAiD;AACjD;;EAEE,+BAA+B;AACjC","sourcesContent":[".resizable-wrapper {\n  position: relative;\n  height: 100%;\n}\n\n.resizable-container {\n  height: 100%;\n  position: relative;\n  transition: width 0.2s ease;\n}\n\n/* Disable transitions during resize */\nbody.resizing-leftbar .resizable-container,\nbody.resizing-leftbar .workspace-sidebar,\nbody.resizing-leftbar .leftbar {\n  transition: none !important;\n}\n\n.resize-handle {\n  position: absolute;\n  right: -8px;\n  top: 0;\n  bottom: 0;\n  width: 16px; /* Wider handle for easier grabbing */\n  cursor: col-resize;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.resize-handle-inner {\n  height: 40px;\n  width: 4px;\n  background-color: transparent;\n  border-radius: 2px;\n  transition: background-color 0.2s;\n}\n\n/* .resize-handle:hover .resize-handle-inner {\n  background-color: rgba(0, 0, 0, 0.1);\n} */\n\n/* .resize-handle:active .resize-handle-inner {\n  background-color: rgba(0, 0, 0, 0.2);\n} */\n\n/* Override react-resizable styles for better appearance */\n.react-resizable-handle {\n  background-image: none !important;\n  width: 16px !important;\n}\n\n/* Add a visual indicator when resizing */\nbody.resizing-leftbar::after {\n  content: '';\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: transparent;\n  z-index: 99;\n  cursor: col-resize;\n}\n\n/* Optimize rendering during resize */\n.resizable-container * {\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n}\n\n/* Ensure sidebar transitions smoothly */\n.workspace-sidebar {\n  transition: left 0.2s ease;\n}\n\n/* Prevent text selection during resize */\nbody.resizing-leftbar {\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n\n/* Improve performance during resize */\nbody.resizing-leftbar * {\n  pointer-events: none;\n}\n\n/* But keep pointer events on the resize handle */\nbody.resizing-leftbar .resize-handle,\nbody.resizing-leftbar .resize-handle * {\n  pointer-events: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
